import { cn } from "@tudigo-monorepo/core-tudigo-theme";

type GuaranteeCardProps = {
  image: string;
  title: string;
  description: string;
  className?: string;
};

const GuaranteeCard = ({ image, title, description }: GuaranteeCardProps) => {
  return (
    <div className="flex max-w-[298px] flex-col gap-4">
      <div className="max-h-[51px] max-w-[67px]">
        <img src={image} alt={title} className="h-auto w-auto" />
      </div>
      <div className="flex flex-col gap-2">
        <p className="text-black-primary text-lg font-bold">{title}</p>

        <p className="text-black-900 text-sm">{description}</p>
      </div>
    </div>
  );
};

const guarantees: GuaranteeCardProps[] = [
  {
    image:
      "https://tudigo-prod.s3.eu-west-3.amazonaws.com/static/website/icon_investment_return.png",
    title: "Un rendement potentiel pour chaque investissement",
    description:
      "Nous négocions les meilleures conditions d’entrée et nos due diligence sont au dessus des standards du marché. Nos chargés d’investissement vous aident à définir la meilleure stratégie selon vos besoins et vos ressources et nous pilotons les sorties de nos investisseurs.",
  },
  {
    image:
      "https://tudigo-prod.s3.eu-west-3.amazonaws.com/static/website/icon_exclusive_projects.png",
    title: "Des projets exclusifs qui ont du sens",
    description:
      "Nous sommes engagés et nous ne sélectionnons que des projets ambitieux qui répondent à un cahier des charges précis, d’ordinaire inaccessibles au grand public. Votre investissement participe à l’économie réelle et à un monde durable et responsable.",
  },
  {
    image:
      "https://tudigo-prod.s3.eu-west-3.amazonaws.com/static/website/icon_certified_platform.png",
    title: "Une plateforme agréée PSFP par l'AMF",
    description:
      "Nos agréments sont régulièrement mis à jour. Pour chaque dossier, vous avez accès au pacte d’associés et à un Document d'Information Réglementaire Synthétique rédigés par nos services. Tudigo est également enregistré ACPR comme agent prestataire de services de paiement.",
  },
  {
    image:
      "https://tudigo-prod.s3.eu-west-3.amazonaws.com/static/website/icon_tax_benefits.png",
    title: "Des avantages fiscaux innovants",
    description:
      "La plupart de nos opportunités d’investissement sont éligibles à des mécanismes de déduction fiscale pouvant aller jusqu’à 50% du montant investi, tels que l’IR-PME, 150 0 B TER, dispositif JEIC, JEIR. Nous vous accompagnons dans les démarches administratives pour en bénéficier.",
  },
];

type GuaranteeBlockProps = {
  className?: string;
};

const GuaranteeBlock = ({ className }: GuaranteeBlockProps) => {
  return (
    <div
      className={cn(
        "grid gap-10 pb-4 pt-4 md:grid-cols-2 lg:grid-cols-4 lg:pb-16 lg:pt-16",
        className,
      )}
    >
      {guarantees.map((guarantee, index) => (
        <GuaranteeCard
          key={index}
          image={guarantee.image}
          title={guarantee.title}
          description={guarantee.description}
        />
      ))}
    </div>
  );
};

export { GuaranteeBlock };
